import { EventChannel } from '@syllepsis/adapter';
var noop = function () { };
var LayerRenderer = /** @class */ (function () {
    function LayerRenderer(adapter, container, viewMapProps, viewContainer, Renderer) {
        var _this = this;
        this.viewMap = {};
        this.layerType = 'template';
        this.curProps = {};
        this.iteratorViewMap = function (cb) {
            return Object.keys(_this.viewMap).forEach(function (name) { return cb(_this.viewMap[name]); });
        };
        this.updateTemplate = function (layerType) {
            if (layerType === void 0) { layerType = 'template'; }
            if (!_this.ViewMap[layerType] || layerType === _this.layerType)
                return;
            _this.viewMap.template.unmount();
            _this.layerType = layerType;
            _this.viewMap.template = new _this.Renderer(_this.adapter, _this.ViewMap[layerType], _this.viewContainer.template);
            _this.viewMap.template.setProps(_this.curProps, noop);
        };
        /**
         * update view if props changed, will update all of cached viewMap
         * at the same time
         */
        this.update = function (props) {
            _this.curProps = props;
            _this.iteratorViewMap(function (renderer) {
                renderer.setProps(props, noop);
            });
        };
        this.container = container;
        this.ViewMap = viewMapProps;
        this.adapter = adapter;
        this.Renderer = Renderer;
        this.viewContainer = viewContainer;
        this.viewMap.template = new Renderer(this.adapter, this.ViewMap.template, viewContainer.template);
        if (!this.ViewMap.mask)
            this.ViewMap.mask = this.ViewMap.template;
        this.viewMap.mask = new Renderer(this.adapter, this.ViewMap.mask, viewContainer.mask);
        adapter.on(EventChannel.LocalEvent.SWITCH_LAYER, this.updateTemplate);
    }
    LayerRenderer.prototype.renderLayer = function () {
        var _this = this;
        this.iteratorViewMap(function (renderer) { return _this.container.appendChild(renderer.container); });
    };
    /**
     * mount card in dom container
     * @param props
     */
    LayerRenderer.prototype.mount = function (props) {
        var childNodes = Array.from(this.container.childNodes);
        for (var _i = 0, childNodes_1 = childNodes; _i < childNodes_1.length; _i++) {
            var child = childNodes_1[_i];
            child.remove();
        }
        this.update(props);
        this.renderLayer();
    };
    /**
     * uninstall all of the Render View
     */
    LayerRenderer.prototype.uninstall = function () {
        this.iteratorViewMap(function (renderer) {
            renderer.unmount();
        });
        this.adapter.off(EventChannel.LocalEvent.SELECTION_CHANGED, this.updateTemplate);
        this.adapter.off(EventChannel.LocalEvent.SWITCH_LAYER, this.updateTemplate);
    };
    return LayerRenderer;
}());
export { LayerRenderer };
//# sourceMappingURL=layer.js.map